<template>
  <div>
    <v-layout row class="mb-4 px-2">
      <v-flex xs12 lg10 offset-lg1 xl8 offset-xl2 class="mt-2" v-if="gewerk">
        <v-breadcrumbs large class="ml-0 pl-0">
          <v-icon slot="divider">chevron_right</v-icon>
          <v-breadcrumbs-item :to="{ name: 'gewerke' }">
            Alle Gewerke
          </v-breadcrumbs-item>
          <v-breadcrumbs-item
            :to="{ name: 'gewerkdetail', params: { id: gewerk.slug } }"
          >
            {{ gewerk.name }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
        <v-layout row wrap>
          <v-flex xs12 sm9 order-xs2 order-sm1>
            <h1 :class="ÜberschriftSize">{{ gewerk.name }}</h1>
          </v-flex>
          <v-flex xs12 sm3 order-xs1 order-sm2 class="mb-4" :class="TextAlign">
            <v-avatar tile size="128" color="grey lighten-4 mb-2" class="elevation-12">
               <img :src="gewerk.logo" :alt="gewerk.name + ' logo'" />  
            </v-avatar>
          </v-flex>
          <v-flex order-xs3 v-if="gewerk.text" class="mt-3">
            <span v-html="gewerk.text" class="subheading"></span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex>
        <v-img
          src="././img/tmp/bg1.webp"
          min-height="320px"
          max-height="390px"
          alt="Handwerker BG"
          cover
          dark
          lazy-src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAICAgICAgICAgIDAgICAwQDAgIDBAUEBAQEBAUGBQUFBQUFBgYHBwgHBwYJCQoKCQkMDAwMDAwMDAwMDAwMDAz/2wBDAQMDAwUEBQkGBgkNCgkKDQ8ODg4ODw8MDAwMDA8PDAwMDAwMDwwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCABUACYDAREAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAL/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB/9k="
        >
          <v-layout row wrap align-center justify-center fill-height>
            <div v-if="gewerk">
              <gewerk-autocomplete
                :key="gewerk.id"
                :gewerk="gewerk"
              ></gewerk-autocomplete>
            </div>
          </v-layout>
        </v-img>
      </v-flex>
    </v-layout>
    <v-layout v-if="gewerk" class="px-1">
      <v-flex xs12 lg10 offset-lg1 xl8 offset-xl2>
        <v-layout row wrap>
          <v-flex class="mt-3">
            <v-layout row wrap v-if="gewerk.leistung.length > 0">
              <v-flex>
                <h3 class="headline my-2">Alle Leistungen</h3>
                <v-layout row wrap>
                  <div
                    v-for="leistung in gewerk.leistung"
                    :key="leistung.id"
                    class="subheading py-2 px-3 mx-1 my-1 grey lighten-2"
                    text-color="grey darken-4"
                    style="border-radius: 2px;"
                  >
                    {{ leistung.leistung }}
                  </div>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout class="mt-5" row wrap v-if="gewerk.innungen.length > 0">
          <v-flex>
            <h3 class="headline">Verknüpfte Innungen</h3>
          </v-flex>
        </v-layout>
        <v-container fluid grid-list-lg v-if="gewerk.innungen.length > 0">
          <v-layout row wrap fill-height>
            <v-flex
              xs12
              sm6
              md4
              grow
              v-for="innung in gewerk.innungen"
              :key="innung.id"
            >
              <innung-card :innung="innung"></innung-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'

import { mapGetters } from 'vuex'
import GewerkAutocomplete from '~/components/gewerke/GewerkAutocomplete.vue'

import InnungCard from '~/components/gewerke/InnungCardColumn.vue'

export default {
  components: {
    GewerkAutocomplete,
    InnungCard
  },
  data () {
    return {
      showcontact: false,
      gewerk: null,
      busy: false,
      bewerben: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'authUser',
      authenticated: 'authCheck'
    }),
    ÜberschriftSize: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'display-1'
      } else {
        return 'display-3'
      }
    },
    TextAlign: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'text-xs-left'
      } else {
        return 'text-xs-right'
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    axios
      .get('/api/v1/gewerk/' + to.params.id)
      .then(resp => {
        next(vm => {
          vm.gewerk = resp.data
          // console.log(resp.data)
        })
      })
      .catch(error => {
        console.log(error)
        //  app.$router.push('/')
        next({ name: '404' })
        // next('/404')
        // next({ name: '404' })
      })
  },
  beforeRouteUpdate (to, from, next) {
    axios
      .get('/api/v1/gewerk/' + to.params.id)
      .then(resp => {
        this.setData(resp.data)
        // app.anzeige = resp.data
        next()
        // next(vm => (vm.anzeige = resp.data))
      })
      .catch(error => {
        console.log(error)

        //  app.$router.push('/')
        next({ name: '404' })
      })
  },
  methods: {
    setData (data) {
      this.gewerk = data
    }
  },
  metaInfo () {
    if (this.gewerk) {
      if (this.gewerk.text) {
        return {
          title: this.gewerk.name + ' Fachbetriebe finden aus Innungen in Ihrer Nähe.',
          meta: [
            { name: 'description', content: this.gewerk.text }
          ]
        }
      } else {
        return {
          title: this.gewerk.name + ' Fachbetriebe finden aus Innungen in Ihrer Nähe.'
        }
      }
    }
  }
}
</script>

<style scoped>
.listbg {
  background: white;
}

.tileright {
  align-items: flex-end;
}

.line-height {
  line-height: 1.5 !important;
}
</style>
